import { useEffect, useState } from "react";
import { Link } from "react-router-dom";


import Pagination from '@mui/material/Pagination';

export const Table = (
    {
        handleEdit,
        filterData,
        handlePrint,
        Filter = false,
        handleChange1,
        UpdateTrunkStatus,
        currentPageNo,
        setFilterData,
        handleFilter,
        handleDelete,
        getTrackingData,
        trackingTabledata,
        loading,
        isModalOpen,
        closeModal,
        handleCheckboxChange,
        tableData, 
    }) => {
    const [checkedItems, setCheckedItems] = useState({});

    const finalHeaderKeys = tableData?.HeadersValue?.filter(

        (key, index) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );
    const finalHeadersValue = tableData?.HeadersKey?.filter(
        (key) => {
            return !tableData?.HideColumns.find((column) => key === column)
        }
    );
    const [ColoredRow, setColoredRow] = useState('')
    const handleHighlight = (id) => {
        setColoredRow(id)
        
    }
    //console.log(tableData?.Actions.length,'tableData?.Actions.lengthtableData?.Actions.lengthtableData?.Actions.lengthtableData?.Actions.length')
    const [serchingData, setSerchingData] = useState([])
    const serching = async () => {
        if (Filter) {
            let data = await
                await fetch(`/api/DashboardController/GetDistrictWiseData`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                })
            setSerchingData(data.dataList)
            setFilterData({ ...filterData, SearchFieldValue: data.dataList[0].valuePart })
        }
    }
   

 

    const countNo = Math.ceil((parseInt(tableData?.TotalRecord) / parseInt(tableData?.PageSize)))
    useEffect(() => {
        serching()
    }, [])

   
    return (

        <>  {
            tableData ? (
                <div className='main-card card border-0' >
                    <div className='card-header mb-1' style={{ backgroundColor:"#d0daff" }}>
                        <div className='row justify-content-between'>
                            <div className='col-md-4'>
                                <b className='m-0' style={{ fontSize: "1rem" }}>{`${tableData.TotalRecord !== undefined ? 'Total Records : ' + tableData?.TotalRecord : 'No Record Found'}`}</b>
                                
                            </div>
                            
                            <div className="col-lg-4">
                                <div className="lms-new-button text-center">
                                    {tableData.Actions?.some(btn => btn === 'CheckBox') && (
                                        <>
                                            <button className="button save-btn" onClick={() => {
                                                UpdateTrunkStatus(true, "PreviousStatus")
                                            }} >
                                                <i className="bi bi-check-lg" /> Previous Status
                                            </button>
                                            <button className="button save-btn" onClick={() => {
                                                UpdateTrunkStatus(true, "NextStatus")
                                            }} >
                                                <i className="bi bi-check-lg" /> Next Status
                                            </button>
                                        </>
                                    )}

                                </div>
                            </div>
                            {/*{Filter ?*/}
                            {/*    <div className='col-md-8 col-lg-6 d-flex flex-row filters'>*/}
                            {/*        <select*/}
                            {/*            value={filterData.SearchFieldValue}*/}
                            {/*            onChange={(e) => setFilterData({ ...filterData, SearchFieldValue: e.target.value })}*/}
                            {/*            className="form-select me-2"*/}
                            {/*            aria-label="Default select example">*/}
                            {/*            {Array.isArray(serchingData) ? (*/}
                            {/*                serchingData?.map((list, i) => (*/}
                            {/*                    <option key={`filterList${i}`} value={list.valuePart}> {list.textPart}</option>*/}
                            {/*                ))*/}
                            {/*            ) : (<></>)}*/}
                            {/*        </select>*/}
                            {/*        <select className="form-select me-2" aria-label="Default select example"*/}
                            {/*            value={filterData.StartValue} onChange={(e) => setFilterData({ ...filterData, StartValue: e.target.value })}*/}
                            {/*        >*/}
                            {/*            <option value="1">Exactly</option>*/}
                            {/*            <option value="2">Contains</option>*/}
                            {/*            <option value="3">Start With</option>*/}
                            {/*        </select>*/}
                            {/*        <input type="text"*/}
                            {/*            className="form-control search"*/}
                            {/*            placeholder="Search"*/}
                            {/*            onKeyDown={(e) => {*/}
                            {/*                if (e.key === 'Enter') {*/}
                            {/*                    handleFilter()*/}
                            {/*                };*/}
                            {/*            }}*/}
                            {/*            value={filterData.SearchText}*/}
                            {/*            onChange={(e) => setFilterData({ ...filterData, SearchText: e.target.value })}*/}
                            {/*        />*/}
                            {/*        <button onClick={handleFilter} className="btn search-btn me-2"><i className="fa-solid fa-magnifying-glass"></i></button>*/}
                            {/*        <button onClick={handleAdvanceFilter} className="btn advance-search-btn"><i className="fa-solid fa-filter"></i></button>*/}
                            {/*    </div>*/}
                            {/*    : <></>}*/}
                        </div>
                    </div>
                    {tableData.TotalRecord === undefined ? <></> :
                        <div className='card-body'>
                            <div className="table-responsive">
                                <table className="table border">
                                    <thead>
                                       
                                        <tr className='light-bg'>
                                            {(tableData?.Actions.length !== 0) ? (
                                                <th>Action</th>
                                            ) : null}
                                            <th>History</th>
                                            {finalHeaderKeys?.map((th, headIndex) => (
                                                <th key={`th${headIndex || 0}`}>{th}</th> || <></>
                                            ))}
                                        </tr>
                                    </thead>
                                    {isModalOpen && (
                                        <div className="modal show" tabIndex="-1" role="dialog">
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content   " style={{ backgroundColor: "#fff" }}>
                                                    <div class="modal-header">
                                                        <h5 class="modal-title font-weight-bold" id="exampleModalLabel">History data</h5>
                                                        {/*<button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={closeModal} style={{ fontWeight: "bold" }}>*/}
                                                        {/*    <span aria-hidden="true">&times;</span>*/}
                                                        {/*</button>*/}
                                                        <button title="History" data-toggle="modal" data-target="#exampleModalCenter" onClick={closeModal} style={{ marginLeft: "10px" }}>
                                                            <i className="fa-solid fa-xmark" /></button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <section className="recoard-table">
                                                            <div className="row">
                                                                <div className="col-lg-12">
                                                                    <div className="content-box">
                                                                        <div className="heading-box d-block d-sm-flex">
                                                                            <div className="heading">
                                                                                <h6 className="m-0 mb-2 mb-sm-0 font-weight-bold text-primary">
                                                                                    {trackingTabledata.totalRecord !== undefined && trackingTabledata.totalRecord !== null ?
                                                                                        (`Total Records : ${trackingTabledata.totalRecord}`)
                                                                                        :
                                                                                        (`No record found`)}
                                                                                </h6>
                                                                            </div>

                                                                        </div>
                                                                        <div className="recoard-bata service-content-area" style={{ padding: "0px" }}>
                                                                            {!loading ?
                                                                                (
                                                                                    <>
                                                                                        <div className="table-responsive " style={{
                                                                                            oveflow: "auto",
                                                                                            maxHeight: "300px"
                                                                                        }}>
                                                                                            {trackingTabledata?.length !== 0 ?
                                                                                                (
                                                                                                    trackingTabledata?.totalRecord !== null ? (<table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                                                                                        <thead className="sticky-top">
                                                                                                            <tr>

                                                                                                                <th>{trackingTabledata.hImage}</th>
                                                                                                                <th>{trackingTabledata.hMap}</th>
                                                                                                                <th>{trackingTabledata.hPacketStatus}</th>
                                                                                                                <th>{trackingTabledata.hEvent}</th>
                                                                                                                <th>{trackingTabledata.hVenue}</th>
                                                                                                                <th>{trackingTabledata.hCustodian}</th>
                                                                                                                <th>{trackingTabledata.hDistrict}</th>
                                                                                                                <th>{trackingTabledata.hVehicleNo}</th>
                                                                                                                <th>{trackingTabledata.hAssignedTo}</th>
                                                                                                                <th>{trackingTabledata.hLatitude}</th>
                                                                                                                <th>{trackingTabledata.hLongitude}</th>
                                                                                                                <th>{trackingTabledata.hCreatedBy}</th>
                                                                                                                <th>{trackingTabledata.hCreatedDate}</th>
                                                                                                                <th>{trackingTabledata.hModifiedBy}</th>
                                                                                                                <th>{trackingTabledata.hModifiedDate}</th>
                                                                                                            </tr>
                                                                                                        </thead>
                                                                                                        <tbody>
                                                                                                            {trackingTabledata?.trackingData !== null ?
                                                                                                                (
                                                                                                                    (trackingTabledata?.trackingData)?.map((event, index) => (
                                                                                                                        <tr key={index}>


                                                                                                                            {/*  <td ><a type="button" href={event.image} target="_blank"> <i className="fa fa-image" style={{ color: "blue" }}></i></a> </td>*/}
                                                                                                                            <td>
                                                                                                                                {event.image ? (
                                                                                                                                    <Link style={{ cursor: 'pointer' }} to={`/Images#data:image/png;base64,${event.image}`} target="_blank">
                                                                                                                                        <i className="fa fa-image" style={{ color: "blue" }}></i>
                                                                                                                                    </Link>
                                                                                                                                ) : (
                                                                                                                                    <div></div>
                                                                                                                                )}
                                                                                                                            </td>
                                                                                                                            <td >
                                                                                                                                {event.map ? (
                                                                                                                                    <a type="button" href={event.map} target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                                                                                                ) : (
                                                                                                                                    <a type="button" href="https://www.google.co.in/maps/@28.6469655,77.0932634,10z?hl=en&entry=ttu" target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                                                                                                )}
                                                                                                                            </td>
                                                                                                                            <td>{event.packetStatus}</td>
                                                                                                                            <td>{event.event}</td>
                                                                                                                            <td>{event.venue}</td>
                                                                                                                            <td>{event.custodian}</td>
                                                                                                                            <td>{event.district}</td>
                                                                                                                            <td>{event.vehicleNo}</td>
                                                                                                                            <td>{event.assignedTo}</td>
                                                                                                                            <td>{event.latitude}</td>
                                                                                                                            <td>{event.longitude}</td>
                                                                                                                            <td>{event.createdBy}</td>
                                                                                                                            <td>{event.createdDate}</td>
                                                                                                                            <td>{event.modifiedBy}</td>
                                                                                                                            <td>{event.modifiedDate}</td>
                                                                                                                        </tr>
                                                                                                                    ))
                                                                                                                ) : (<></>)}
                                                                                                        </tbody>
                                                                                                    </table>) : (<></>)

                                                                                                ) : (<></>)}
                                                                                        </div>
                                                                                        {countNo > 1 ?''
                                                                                            /*<Pagination count={countNo} variant="outlined" page={currentPageNo} shape="rounded" />*/

                                                                                           : ''}
                                                                                    </>
                                                                                ) : (
                                                                                    <div className='d-flex align-items-center justify-center'>

                                                                                    </div>
                                                                                )
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </section>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <tbody>
                                        {tableData?.Data?.map((item, bodyIndex) => (    
                                            <tr key={`row${bodyIndex}`} className="tablerow"  onClick={() => handleHighlight(bodyIndex)} style={{ background: bodyIndex === ColoredRow ? '#cbe2ff' : '' }}>
                                              
                                                {tableData?.Actions.length != 0 ? (
                                                    <td className={tableData.Actions?.some(btn => btn === 'CheckBox') ? '' : 'd-flex'}>
                                                        {tableData.Actions?.map((btn, index) => (
                                                            <>
                                                                {btn === 'Edit' ?
                                                                    <button key={`edit${index}`} className="btn btn-xs sharp me-1" onClick={() => handleEdit(item.Edit)}>
                                                                        <i className="fa-regular fa-pen-to-square text-success" />
                                                                    </button> : (<></>)}
                                                                {btn === 'Del' ?
                                                                    <button key={`del${index}`} className="btn btn-xs sharp" onClick={() => handleDelete(item.Del)}>
                                                                        <i className="fa-regular fa-trash-can text-danger" />
                                                                    </button> : (<></>)}
                                                                {btn === 'Print' ?
                                                                    <button key={`print${index}`} className="btn btn-xs sharp" onClick={() => handlePrint(item.Print)}>
                                                                        <i className="fa fa-download text-primary" />
                                                                    </button> : (<></>)}
                                                                {btn === 'CheckBox' ?
                                                                    <input
                                                                        className="form-check-input mt-0"
                                                                        type="checkbox"
                                                                        checked={item.checkStatus}
                                                                        id={item.CheckBox}
                                                                        style={{ height: '13px', width: '13px' }}
                                                                        onChange={(e) => handleCheckboxChange(e.target.checked, item.CheckBox, bodyIndex)}
                                                                       
                                                                    /> : (<></>)}
                                                            </>
                                                        ))}
                                                    </td>
                                                ) : (
                                                    <></>
                                                )}

                                                <td >
                                                    <button
                                                        title="History"
                                                        data-toggle="modal"
                                                        data-target="#exampleModalCenter"
                                                        key={bodyIndex}
                                                        onClick={() => getTrackingData('',`${item.TrunkID}`)}
                                                        style={{ marginLeft: "10px" }}>
                                                        <i className="fa-solid fa-server" style={{ color: "black" }} />
                                                    </button>
                                                </td>


                                                <td  >
                                                    {item.Map ? (
                                                        <a type="button" href={item.Map} target="_blank"> <i className="fas fa-map-marker-alt" style={{ color: "blue" }}></i></a>
                                                    ) : (
                                                        <div></div>
                                                    )}
                                                </td>
                                                <td>

                                                    <Link style={{ cursor: 'pointer' }} to={`/QrCode#data:image/png;base64,${item.QR}`} target="_blank">
                                                        <i className="fa fa-qrcode" style={{ fontSize: "19px", }}></i>
                                                    </Link>
                                                </td>

                                                {/*{finalHeadersValue?.filter((key, tdIndex) => (*/}
                                                {/*    <>*/}
                                                {/*    <td key={`key${tdIndex}`}>{item[key]}</td>*/}
                                                {/*    </>*/}
                                                {/*))}*/}

                                                {finalHeadersValue.filter((value) => (value !== 'Map') && (value !=="QR")).map((key, tdIndex) => (
                                                    <>
                                                        <td key={`key${tdIndex}`}>{item[key]}</td>
                                                    </>
                                                )
                                                
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {countNo > 1 ?
                                < Pagination className='pt-2' count={countNo} variant="outlined" page={currentPageNo} onChange={handleChange1} shape="rounded" />
                                : ''}
                        </div>
                    }
                </div >
            ) : (<></>)
        }

        </>
    )
}